import React from 'react';
import PropTypes from 'prop-types';
// Local Deps
// import { Button } from 'antd';
import './SuperAdminMenu.scss';
import {
  entityMemberManagement,
  // siteManagement,
  // StdSpecManagement,
} from '../../config/searchFilters/SuperAdminFilters';
// import { updateUserMetaData } from '../grids/PendingRequest/graphql';

// Components
import FilterGroup from '../FilterGroup';

export default class SuperAdminMenu extends React.PureComponent {
  static propTypes = {
    selectedMenu: PropTypes.object,
    onMenuClick: PropTypes.func,
    auth: PropTypes.object.isRequired,
    // govOrgId: PropTypes.string.isRequired,
  };

  static defaultProps = {
    selectedMenu: { value: 'viewReqs' },
    onMenuClick: () => { },
  };
  render() {
    // const { selectedMenu, onMenuClick, govOrgId, auth } = this.props;
    const { selectedMenu, onMenuClick } = this.props;
    return (
      <div className="nf-solicitations-menu">
        <FilterGroup
          {...entityMemberManagement}
          onFilterClick={onMenuClick}
          selectedFilter={[selectedMenu.value]}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '8px',
          }}
        >
          {/* The below section addes the toggle to government administration button. */}
          {/* {selectedMenu.value !== 'searchUsers' &&
            selectedMenu.value !== 'viewEntities' && (
              <Button
                onClick={async () => {
                  const res = await updateUserMetaData(auth.id, govOrgId);
                  if (res) {
                    // gotta remove the cookie or it will load the old cookie info on the redirect

                    document.cookie =
                      'idToken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';

                    window.location.replace(
                      '/login?redirect=%2Fmemberadmin%2Fhome%2FviewUsers',
                    );
                  }
                }}
              >
                Government Administration
              </Button>
            )} */}
        </div>

        {/* <FilterGroup
          {...siteManagement}
          onFilterClick={onMenuClick}
          selectedFilter={[selectedMenu.value]}
        />
        <FilterGroup
          {...StdSpecManagement}
          onFilterClick={onMenuClick}
          selectedFilter={[selectedMenu.value]}
        /> */}
      </div>
    );
  }
}

// export default SuperAdminHOC(SuperAdminMenu)



// WEBPACK FOOTER //
// ./src/components/SuperAdminMenu/SuperAdminMenu.jsx